import { render } from "./ManagerDetail.vue?vue&type=template&id=2ef5584d&scoped=true"
import script from "./ManagerDetail.vue?vue&type=script&lang=js"
export * from "./ManagerDetail.vue?vue&type=script&lang=js"

import "./ManagerDetail.vue?vue&type=style&index=0&id=2ef5584d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef5584d"]])

export default __exports__